import { oktaAuthStore } from 'src/auth/oktaAuthStore';
import { ContentType, RequestParams } from './types';
import { apiRequest } from './api';
import { PEP_API_PATH, PEP_API_PATH_V2, PEP_API_PATH_V3 } from './constants';

export const pepApiRequest = ({
  headers,
  url,
  useProxy = true,
  useSessionProxy = false,
  ...rest
}: RequestParams) => {
  const Authorization = `Bearer ${oktaAuthStore.getAccessToken()}`;

  let basePath: string;
  if (useSessionProxy) {
    basePath = PEP_API_PATH_V3;
  } else if (useProxy) {
    basePath = PEP_API_PATH;
  } else {
    basePath = PEP_API_PATH_V2;
  }

  return apiRequest({
    contentType: ContentType.JSON,
    headers: {
      Authorization,
      ...headers,
    },
    url: basePath + url,
    ...rest,
  });
};
